import { gate } from 'hub-http/gates';
export const GATES = {
  APPROVAL_DUE_DATE: gate('ProductApprovals::Platform::DueDate')
};